import {useCallback, useContext, useEffect, useState} from "react";
import {AppDataContext} from "../../../App";
import UseApiManager from "../../../core/manager/api";
import MaplibreManager, {OverwriteMode} from "../../../core/manager/maplibre";
import PropTypes from "prop-types";


const SourceName = "tree"

export const LayerName = {
    Circle: {id: "tree-circle-layer", at: 2},
    Buffer: {id: "tree-buffer-layer", at: 1},
}

const MapTreeLayer = ({
  map,
  filter,
  visible,
  style,
  onClick,
  onInit,
  onLoadStart,
  onLoadFinish,
  onLoadError
}) => {

    const { state } = useContext(AppDataContext)
    const [url, setUrl] = useState()
    const { QueryVectorTileUrl, QueryVectorTreeTileUrl } = UseApiManager()
    const {
        addVectorSource,
        zoomInterpolate,
        addLayer,
        addClickEvent,
        removes,
        setVisible,
    } = MaplibreManager()

    const [treeFilter, setTreeFilter] = useState()


    useEffect(() => {

        onLoadStart && onLoadStart()

        QueryVectorTreeTileUrl(state.filterModel)
            .then(setUrl)
            .catch(onLoadError)
            .finally(onLoadFinish)
        //
        // QueryVectorTileUrl(`
        // SELECT
        //     tree_uid,
        //     tree_id,
        //     name,
        //     type,
        //     fill_color,
        //     the_geom_webmercator,
        //     latitude,
        //     longitude
        // FROM ${state.env.CLIENT_TREE_VIEW}
        // WHERE ${wheres.join(' AND ')}
        // `).then(setUrl)
    }, [state.treeRefreshTime, state.user, state.filterModel])

    useEffect(() => {
        setVisible(map, LayerName, visible)
    }, [map, visible])

    const initLayer = useCallback(() => {
        console.log("[Tree]", "init layer", map, url)
        if (!map || !url) { return }

        addVectorSource(map, SourceName, url, OverwriteMode.Rewrite)
        addLayer(map, {
            id: LayerName.Circle.id,
            type: "circle",
            source: SourceName,
            sourceLayer: "layer0",
            paint: {
                circleColor: ["get", "fill_color"],
                circleOpacity: 0.8,
                circleRadius: zoomInterpolate({8:1,10:3,14:5,18:11}),
                circleStrokeColor: "#ffffff",
                circleStrokeWidth: zoomInterpolate({8:0,10:0.1,14:0.5,18:1}),
            },
            layout: {
                visibility: visible ? "visible": "none",
            }
        }, OverwriteMode.Rewrite)
        addLayer(map, {
            id: LayerName.Buffer.id,
            type: "circle",
            source: SourceName,
            sourceLayer: "layer0",
            paint: {
                circleColor: "#ffffff",
                circleOpacity: 0.01,
                circleRadius: zoomInterpolate({8:1,10:8,14:10,18:16}),
            },
            layout: {
                visibility: visible ? "visible": "none",
            }
        }, OverwriteMode.Rewrite)

        addClickEvent(map, LayerName, onLayerClick)

        setVisible(map, LayerName, visible)
        //updateVisible()
        //updateFilter()

        onInit && onInit()

    }, [map, url, onInit, visible])

    useEffect(() => {
        if (!map) { return }

        setTimeout(initLayer, 500)

        return () => {
            removes(map,{sources: SourceName, layers: LayerName})
        }

    }, [map, url, style])

    const onLayerClick = useCallback((e) => {
        onClick && onClick(e.features[0].properties)
    }, [map, onClick])


    return null
}

MapTreeLayer.propTypes = {
    map: PropTypes.any,
    visible: PropTypes.bool,
    style: PropTypes.string,
    onLoadStart: PropTypes.func,
    onLoadError: PropTypes.func,
    onLoadFinish: PropTypes.func,
    onClick: PropTypes.func,
    onInit: PropTypes.func,
}

export default MapTreeLayer
